<script>
export default {
  name: 'InitialPopup',
  props: {
    title: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      default: null,
    },
    back: {
      type: String,
      required: true,
    },
    close: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.focusFirst();
  },
  methods: {
    closePopup() {
      // destroy the vue listeners, etc
      this.$destroy();

      // remove the element from the DOM
      this.$el.parentNode.removeChild(this.$el);
    },
    focusFirst() {
      this.$refs.first.focus();
    },
    focusLast() {
      this.$refs.last.focus();
    },
    previousPage() {
      window.history.back();
    },
  },
};
</script>
<template>
  <div
    aria-modal="true"
    class="popup"
    role="dialog"
    transition="modal"
    @keydown.esc="closePopup"
  >
    <span
      class="popup__overlay"
      @click="closePopup"
    />

    <div class="popup__wrapper theme--white">
      <div
        tabindex="0"
        @focus.prevent="focusLast"
      />

      <button
        ref="first"
        class="popup__close"
        @click.prevent="closePopup"
      >
        <span class="sr-only">{{ close }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15.983"><path d="M1.772 0A1.774 1.774 0 00.537 3.046L5.491 8 .537 12.955a1.774 1.774 0 102.509 2.509L8 10.509l4.954 4.954a1.774 1.774 0 102.509-2.509L10.508 8l4.954-4.954A1.774 1.774 0 1012.954.538L7.999 5.492 3.045.537A1.774 1.774 0 001.772 0z"/></svg>
      </button>

      <div class="popup__content">
        <strong class="popup__title">
          {{ title }}
        </strong>
        <div
          v-if="desc"
          class="popup__desc"
        >
          {{ desc }}
        </div>
      </div>

      <div class="popup__options">
        <button
          class="btn btn--black"
          @click="previousPage"
        >
          <span class="btn__content">
            <span class="btn__text">{{ back }}</span>
          </span>
        </button>

        <button
          ref="last"
          class="btn btn--black"
          @click="closePopup"
        >
          <span class="btn__content">
            <span class="btn__text">{{ close }}</span>
          </span>
        </button>
      </div>

      <div
        tabindex="0"
        @focus="focusFirst"
      />
    </div>
  </div>
</template>
